<template>
<div>
  <!-- Overlay For Sidebars -->
  <div class="overlay"></div>

  <!-- Main Search -->
  <!--<div id="search">
    <button id="close" type="button"
      class="close btn btn-primary btn-icon btn-icon-mini btn-round">x</button>
    <form>
        <input type="search" value="" placeholder="Buscar..." />
        <button type="submit" class="btn btn-primary">Buscar</button>
    </form>
  </div>-->

  <!-- Right Icon menu Sidebar -->
  <!-- <MenuSidebar /> -->

  <!-- Left Sidebar -->
  <LeftSidebar />

  <!-- Right Sidebar -->
  <!-- <RightSidebar />-->

  <!-- Main Content -->
  <section class="content">
    <div class="body_scroll">
      <!-- Breadcrumb -->
      <!-- <div class="block-header">
          <div class="row">
              <div class="col-lg-7 col-md-6 col-sm-12">
                  <ul class="breadcrumb">
                      <li class="breadcrumb-item">
                        <a href="index.html">
                          <i class="zmdi zmdi-home"></i>Inicio
                        </a>
                      </li>
                      <li class="breadcrumb-item active">Tablero</li>
                  </ul>
                  <button class="btn btn-primary btn-icon mobile_menu" type="button">
                    <i class="zmdi zmdi-sort-amount-desc"></i>
                  </button>
              </div>
              <div class="col-lg-5 col-md-6 col-sm-12">
                  <button class="btn btn-primary btn-icon float-right right_icon_toggle_btn"
                  type="button"><i class="zmdi zmdi-arrow-right"></i></button>
              </div>
          </div>
      </div>-->
      <div class="container-fluid">
        <router-view/>
      </div>

      <!-- Select language -->
      <Language />
    </div>
  </section>
</div>
</template>

<script>
// import MenuSidebar from '../../components/panel/MenuSidebar.vue';
// import RightSidebar from '../../components/panel/RightSidebar.vue';
import LeftSidebar from '../../components/panel/LeftSidebar.vue';
import Language from '../../components/panel/Language.vue';

export default {
  name: 'layout',
  components: {
    // MenuSidebar,
    // RightSidebar,
    LeftSidebar,
    Language,
  },
};
</script>

<style>
  .pointer {
    cursor: pointer;
  }
</style>
